import React from 'react';

type Props = React.HTMLAttributes<HTMLHeadingElement> & {
    icon: string;
    isActive: boolean;
    content: string;
};

export function IconTitle({ icon, isActive, content, ...props }: Props) {
    return (
        <h2
            className={`flex cursor-pointer items-center text-2xl text-super-medium font-medium card-expanded ${isActive ? 'card-expanded-active' : ''}`}
            {...props}
        >
            <img
                src={icon}
                className={`mr-2 h-8 w-8 transition-all duration-100 ${!isActive ? 'opacity-50 grayscale' : ''}`}
                alt={content}
            />
            {content}
        </h2>
    );
}
